export class Player {
    constructor(name, preview, chatImage, sprite, inventory) {
        this.name = name;
        this.preview = preview;
        this.chatImage = chatImage;
        this.sprite = sprite;
        this.inventory = inventory;
    }
    toJSON() {
        return {
            name: this.name,
            preview: this.preview,
            chatImage: this.chatImage,
            sprite: this.sprite,
            inventory: [...this.inventory],
        };
    }
}
